import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useAuthState } from "@/hooks/useAuthState";

const Sitemap = () => {
  const { isAuthenticated, userType, userName, userPhoto, userId } = useAuthState();

  const sections = [
    {
      title: "Principal",
      links: [
        { name: "Home", path: "/" },
        { name: "Buscar Imóveis", path: "/busca" },
        { name: "Entrar", path: "/entrar" },
        { name: "Cadastre-se", path: "/cadastro" },
      ],
    },
    {
      title: "Sobre",
      links: [
        { name: "Sobre Nós", path: "/sobre" },
        { name: "Como Funciona", path: "/sobre" },
        { name: "Carreiras", path: "/sobre" },
      ],
    },
    {
      title: "Suporte",
      links: [
        { name: "Central de Ajuda", path: "/ajuda" },
        { name: "Fale Conosco", path: "/fale-conosco" },
        { name: "Mensagens", path: "/mensagens" },
      ],
    },
    {
      title: "Legal",
      links: [
        { name: "Termos de Uso", path: "/termos" },
        { name: "Política de Privacidade", path: "/privacidade" },
        { name: "Mapa do Site", path: "/sitemap" },
      ],
    },
  ];

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Navbar 
        isAuthenticated={isAuthenticated} 
        isOwner={userType === "owner"} 
        userName={userName}
        userPhoto={userPhoto}
        userId={userId}
        userType={userType}
      />

      <main className="flex-1 container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold text-center mb-4">Mapa do Site</h1>
          <p className="text-center text-muted-foreground mb-12">
            Navegue facilmente por todas as páginas da Live Stay
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {sections.map((section) => (
              <Card key={section.title}>
                <CardHeader>
                  <CardTitle>{section.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-3">
                    {section.links.map((link) => (
                      <li key={link.path}>
                        <Link
                          to={link.path}
                          className="text-muted-foreground hover:text-primary transition-colors"
                        >
                          {link.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Sitemap;
